/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Clean_Cobra_SucceedInputs */

const fr_equal_clean_cobra_succeed = /** @type {(inputs: Equal_Clean_Cobra_SucceedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair`)
};

/**

* @param {Equal_Clean_Cobra_SucceedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_clean_cobra_succeed = /** @type {((inputs?: Equal_Clean_Cobra_SucceedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Clean_Cobra_SucceedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_clean_cobra_succeed(inputs)
});